export const meta = {
  title: '隐私政策 | gridcraft',
  description:
    '了解 gridcraft 如何处理浏览信息、支持邮件、Cookie 以及第三方下载链接。',
  updated_at: '2026-10-18',
};

## 关于本网站

gridcraft（gridcraft.me）是一个独立的信息网站，提供 GridCraft 下载入口、安装指南、与 Microsoft Excel 的功能对比及使用体验。本政策适用于本站及我们的支持邮件往来。联系邮箱：[support@gridcraft.me](mailto:support@gridcraft.me)。

## 我们处理的信息

- **浏览信息：** 访问请求可能包含 IP 地址、浏览器与设备信息、访问页面、来源信息和时间。这些信息用于提供网页、排查错误和防止滥用。
- **支持邮件：** 您发邮件联系我们时，我们会收到您的邮箱地址、邮件内容及您主动提供的附件，用于回复和调查问题。
- **账户功能：** 如果您使用本站开放的登录或支持功能，我们会处理您提交的信息及提供该功能所需的会话信息。

发送截图或文件前，请移除密码、许可密钥、个人资料及电子表格中的机密数据。

## Cookie 与浏览器存储

网站会根据功能需要使用 Cookie 或浏览器存储，例如记住语言偏好和维持登录状态。您可以通过浏览器管理 Cookie 和网站数据，禁用后可能影响相关功能。如果启用了数据分析工具，这些工具可能处理页面浏览、设备信息和交互数据，以帮助我们了解网站使用情况。可选追踪应遵循适用于您的同意设置。

## 下载、外部链接与编辑器

下载入口可能跳转至软件发布者或其他第三方平台，这些服务依据各自的隐私政策处理信息。您安装的软件也适用其发布者的条款和隐私规则。

如果您使用内嵌电子表格编辑器，文件的处理方式取决于所嵌入的软件及您使用的具体功能。请勿默认所有操作都离线完成，或文件已获得云端备份。重要工作簿请另行保存副本。

## 信息用途与共享

我们使用信息来运营和保护网站、回复支持请求及改进指南。托管、邮件及已启用的数据分析服务商可能处理完成上述任务所需的信息。我们不会出售您的个人信息。在适用法律要求或处理滥用行为时，也可能披露必要信息。

## 保留与安全

我们仅在实现上述目的所需的期间保留信息，包括支持、安全及适用的记录保留义务。具体期限取决于信息类型和相关服务商。我们采取合理措施保护信息，但无法保证绝对安全。

## 您的选择

您可以管理浏览器存储、停止使用可选功能，或通过邮件申请查阅、更正或删除您的信息。我们可能需要核实您的身份，并会按照适用要求处理请求，包括保留必须保留的记录。除非我们通过约定的安全方式明确要求，请勿发送身份证件。

## 儿童与政策更新

本站面向一般受众，不会有意向儿童索取个人信息。如儿童提交了个人信息，家长或监护人可联系我们处理。我们可能随网站变化更新本政策，修订日期见页首。

## 联系我们

隐私相关问题和请求：[support@gridcraft.me](mailto:support@gridcraft.me)。
